import { formatMoney } from '@theme/money-formatting';
// Presentation adapter only. Native named inputs and PriceFacetComponent own filtering.
class GomitoloPriceRange extends HTMLElement {
  connectedCallback() {
    this.addEventListener('input', this.update);
    this.addEventListener('change', this.commit);
    this.addEventListener('keydown', this.allowRangeKeys);
    this.paint();
  }
  disconnectedCallback() {
    this.removeEventListener('input', this.update);
    this.removeEventListener('change', this.commit);
    this.removeEventListener('keydown', this.allowRangeKeys);
  }
  allowRangeKeys = (event) => { event.stopPropagation(); };
  update = (event) => {
    if (!(event.target instanceof HTMLInputElement)) return;
    const low = this.querySelector('[data-range-min]');
    const high = this.querySelector('[data-range-max]');
    if (event.target === low) low.value = String(Math.min(Number(low.value), Number(high.value)));
    else high.value = String(Math.max(Number(high.value), Number(low.value)));
    const facet = this.closest('price-facet-component');
    const nativeInput = facet?.querySelector(event.target === low ? '[ref="minInput"]' : '[ref="maxInput"]');
    const moneyPlaceholder = this.dataset.moneyFormat.match(/{{\s*\w+\s*}}/)?.[0] || '{{amount}}';
    if (nativeInput) nativeInput.value = formatMoney(Number(event.target.value), moneyPlaceholder, this.dataset.currency);
    this.paint();
  };
  commit = (event) => {
    event.stopPropagation();
    this.update(event);
    const nativeInput = this.closest('price-facet-component')?.querySelector(event.target.hasAttribute('data-range-min') ? '[ref="minInput"]' : '[ref="maxInput"]');
    nativeInput?.dispatchEvent(new Event('change', { bubbles:true }));
  };
  paint() {
    const low = this.querySelector('[data-range-min]');
    const high = this.querySelector('[data-range-max]');
    const max = Number(this.dataset.max) || 1;
    const track = this.querySelector('.gomitolo-price-range__track span');
    if (!low || !high || !track) return;
    for (const input of [low, high]) {
      input.setAttribute('aria-valuetext', formatMoney(Number(input.value), this.dataset.moneyFormat, this.dataset.currency).replace(/<[^>]*>/g, ''));
    }
    track.style.left = `${Number(low.value) / max * 100}%`;
    track.style.right = `${100 - Number(high.value) / max * 100}%`;
    low.style.zIndex = Number(low.value) === Number(high.value) && Number(high.value) === max ? '2' : '1';
  }
}
if (!customElements.get('gomitolo-price-range')) customElements.define('gomitolo-price-range', GomitoloPriceRange);
